<div class="dropdown-button" (click)="onTapDropdown()">
  <div class="display" [class.centered]="centered" [style.color]="displayColor">{{ displayText }}</div>
  <div>
    <ion-icon slot="end" name="caret-down-outline" class="icon-arrow" style="margin:0 !important;" [style.color]="displayColor"></ion-icon>
  </div>
</div>